export default __webpack_public_path__ + "static/gingerbreadPrison-3f634ac7c9ae23a52c5613167db5cb62.svg";